import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
// Category positioning in the browser tab (full per-language <head> meta is set at deploy).
document.title = "BCITI · Trusted Intelligence Infrastructure";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-684" />);
}